<script setup lang="ts">
import { ref, type PropType } from 'vue';
import { type FormField } from '@/models/form';
import Select from 'primevue/select';
import type { DrillData } from '@/components';
import { useI18n } from 'vue-i18n';

const { t: $t } = useI18n();

const props = defineProps({
  field: {
    type: Object as PropType<FormField>,
    required: true
  },
  previewMode: {
    type: Boolean
  }
});

const localField = ref<FormField>(props.field);

const onChange = (index: number) => {
  if (!localField.value.drillValue![index]) {
    let currentIndex = index;
    while (currentIndex < localField.value.drillValue!.length) {
      localField.value.drillValue!.splice(currentIndex, 1);
      currentIndex++;
    }
  }
};
</script>

<template>
  <div class="item-root" v-if="localField.drillValue">
    <div class="select"
      v-for="(level, index) in localField.options.drillLevels"
      :key="level.order">
      <div class="label"><strong>{{ level.label }}</strong></div>
      <Select v-model="localField.drillValue![index]"
        class="select-input"
        optionLabel="label"
        :placeholder="$t('select')"
        filter
        showClear
        @change="onChange(index)"
        :disabled="index > 0 && (!localField.drillValue![index - 1]) || previewMode"
        :options="
          index === 0 ?
            level.data :
            level.data.filter(level => level.parentId === (localField.drillValue![index - 1] as unknown as DrillData)?.id)
        "/>
    </div>
  </div>
</template>

<style scoped lang="scss">
.select {
  padding: 12px 0px;
  font-size: 14px;
}
.select-input {
  margin-top: 8px;
  width: 100%;
}
</style>
